/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 *
 * @export
 */
export const FlightSearchStatus = {
    Success: 'success',
    NoResults: 'no_results',
    ProviderFailure: 'provider_failure',
    ProviderBlocked: 'provider_blocked',
    ParseFailure: 'parse_failure',
    InvalidRequest: 'invalid_request'
} as const;
export type FlightSearchStatus = typeof FlightSearchStatus[keyof typeof FlightSearchStatus];


export function instanceOfFlightSearchStatus(value: any): boolean {
    for (const key in FlightSearchStatus) {
        if (Object.prototype.hasOwnProperty.call(FlightSearchStatus, key)) {
            if (FlightSearchStatus[key as keyof typeof FlightSearchStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FlightSearchStatusFromJSON(json: any): FlightSearchStatus {
    return FlightSearchStatusFromJSONTyped(json, false);
}

export function FlightSearchStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightSearchStatus {
    return json as FlightSearchStatus;
}

export function FlightSearchStatusToJSON(value?: FlightSearchStatus | null): any {
    return value as any;
}

export function FlightSearchStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): FlightSearchStatus {
    return value as FlightSearchStatus;
}
